<template>
  <div class="home-container">
    <div class="top-wrapper">
      <router-link to="/purchase">
        <div class="text-wrapper">
          <div class="title">
            传统采购订单
          </div>
          <div class="number">
            {{ purchaseTotal }}
          </div>
        </div>
        <div class="icon">
          <i class="iconfont icon-order"></i>
        </div>
      </router-link>
      <router-link to="/indent">
        <div class="text-wrapper">
          <div class="title">
            委托采购订单
          </div>
          <div class="number">
            {{ indentTotal }}
          </div>
        </div>
        <div class="icon">
          <i class="iconfont icon-order"></i>
        </div>
      </router-link>
      <router-link to="/requirement">
        <div class="text-wrapper">
          <div class="title">
            待报价需求
          </div>
          <div class="number">
            {{ requirementTotal }}
          </div>
        </div>
        <div class="icon">
          <i class="iconfont icon-order"></i>
        </div>
      </router-link>
      <router-link to="/recommend">
        <div class="text-wrapper">
          <div class="title">
            产品推荐
          </div>
          <div class="number">
            {{ recommendTotal }}
          </div>
        </div>
        <div class="icon">
          <i class="iconfont icon-order"></i>
        </div>
      </router-link>
    </div>
    <div class="main-wrapper">
      <el-menu
        :default-active="activeIndex"
        @select="handleSelect"
        background-color="#ffffff"
        text-color="#2F343C"
        active-text-color="#2771FF"
        mode="horizontal"
      >
        <el-menu-item index="purchase" style="background-color:#ffffff">
          <span slot="title">传统采购订单</span>
        </el-menu-item>
        <el-menu-item index="indent" style="background-color:#ffffff">
          <span slot="title">委托采购订单</span>
        </el-menu-item>
        <el-menu-item index="requirement" style="background-color:#ffffff">
          <span slot="title">需求信息</span>
        </el-menu-item>
        <el-menu-item index="recommend" style="background-color:#ffffff">
          <span slot="title">产品推荐</span>
        </el-menu-item>
      </el-menu>
      <div class="preview-wrapper">
        <home-purchase v-if="activeIndex == 'purchase'" />
        <home-indent v-else-if="activeIndex == 'indent'" />
        <home-requirement v-else-if="activeIndex == 'requirement'" />
        <home-recommend v-if="activeIndex == 'recommend'" />
      </div>
    </div>
  </div>
</template>

<script>
import HomePurchase from '@/components/home/HomePurchase'
import HomeIndent from '@/components/home/HomeIndent'
import HomeRequirement from '@/components/home/HomeRequirement'
import HomeRecommend from '@/components/home/HomeRecommend'
export default {
  components: {
    'home-purchase': HomePurchase,
    'home-indent': HomeIndent,
    'home-requirement': HomeRequirement,
    'home-recommend': HomeRecommend
  },
  data() {
    return {
      activeIndex: 'purchase',
      purchaseTotal: 0,
      indentTotal: 0,
      requirementTotal: 0,
      recommendTotal: 0
    }
  },
  beforeCreate() {
    this.$store.commit('setActiveIndex', '/home')
    this.$store.commit('setAsideWidth', 150)
  },
  created() {
    this.getPurchaseList()
    this.getIndentList()
    this.getRequirementCount()
    this.getRecommendCount()
  },
  mounted() {},
  methods: {
    handleSelect(key) {
      this.activeIndex = key
    },
    getPurchaseList() {
      const params = {
        docEntry: '',
        material: '',
        state: '',
        skipCount: 0,
        maxResultCount: 10
      }
      this.$http
        .get('/api/services/inquiryApp/purchaseOrder/GetSapAll', params)
        .then(res => {
          this.purchaseTotal = res.result.totalCount
        })
        .catch(err => {
          console.log(err)
        })
    },
    getIndentList() {
      const params = {
        state: '',
        skipCount: 0,
        maxResultCount: 10
      }
      this.$http
        .get('/api/services/inquiryApp/entrust/GetAll', params)
        .then(res => {
          this.indentTotal = res.result.totalCount
        })
        .catch(err => {
          console.log(err)
        })
    },
    getRequirementCount() {
      this.$http.get('/api/services/inquiryApp/dIDetail/GetCount').then(res => {
        this.requirementTotal = res.result
      })
    },
    getRecommendCount() {
      this.$http
        .get('/api/services/inquiryApp/productRecommend/GetCount')
        .then(res => {
          this.recommendTotal = res.result
        })
        .catch(err => {
          console.log(err)
        })
    }
  }
}
</script>
<style lang="less" scoped>
.home-comtainer {
  font-family: 'Source Han Sans CN';
}
.top-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
  > a {
    width: 24%;
    height: 106px;
    border-radius: 10px;
    display: flex;
    cursor: pointer;
    .text-wrapper {
      height: 106px;
      flex: 1;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: center;
      padding: 25px 0;
      border-radius: 10px 0 0 10px;
      .title {
        font-size: 16px;
        color: #ffffff;
      }
      .number {
        font-size: 24px;
        color: #ffffff;
      }
    }
    .icon {
      width: 92px;
      height: 106px;
      border-radius: 0 10px 10px 0;
      display: flex;
      justify-content: center;
      align-items: center;
      .icon-order {
        font-size: 34px;
        color: rgba(256, 256, 256, 0.5);
      }
    }
    &:first-child {
      .text-wrapper {
        background-color: #6252ff;
      }
      .icon {
        background-color: #6e5bff;
      }
    }
    &:nth-child(2) {
      .text-wrapper {
        background-color: #1b94ff;
      }
      .icon {
        background-color: #309eff;
      }
    }
    &:nth-child(3) {
      .text-wrapper {
        background-color: #0e61ff;
      }
      .icon {
        background-color: #2771ff;
      }
    }
    &:nth-child(4) {
      .text-wrapper {
        background-color: #00b8b8;
      }
      .icon {
        background-color: #04c2c2;
      }
    }
  }
}
.main-wrapper {
  height: calc(100% - 130px);
  width: 100%;
  position: relative;
  background-color: #ffffff;
  margin-top: 25px;
  box-shadow: 0px 0px 12px rgba(212, 218, 255, 1);
  overflow: auto;
  .el-menu {
    height: 50px;
    width: calc(100% - 190px);
    position: fixed;
    display: flex;
    justify-content: space-between;
    align-items: center;
    z-index: 100;
    .el-menu-item {
      height: 49px;
      line-height: 50px;
      font-size: 16px;
      font-weight: 600;
      user-select: none;
      background-color: #fff !important;
      &:hover {
        border-bottom: 2px solid #409eff !important;
        color: #409eff !important;
        background-color: #ffffff !important;
      }
    }
  }
  .preview-wrapper {
    margin-top: 50px;
  }
}
.bottom-wrapper {
  background-color: #eff2f9;
  margin-top: 25px;
  box-shadow: 0px 0px 12px rgba(212, 218, 255, 1) !important;
  .el-menu {
    height: 50px;
    background-color: #ffffff;
    display: flex;
    align-items: center;
    box-shadow: 0px 0px 12px rgba(212, 218, 255, 1) !important;
    .el-menu-item {
      height: 49px;
      line-height: 50px;
      margin: 0 20px;
      font-size: 16px;
      font-weight: 600;
      user-select: none;
      &:hover {
        border-bottom: 2px solid #409eff !important;
        color: #409eff !important;
        background-color: #ffffff !important;
      }
    }
  }
}
.bottom-content {
  margin-top: 15px;
  display: flex;
  justify-content: space-between;
  #compare {
    width: 270px;
    height: 240px;
    margin-right: 20px;
    background-color: #ffffff;
  }
  #trend {
    flex: 1;
    height: 240px;
    background-color: #ffffff;
  }
}
</style>
